import React, { useEffect, useState } from 'react';
import { barWidth, percent } from './format';

interface GhgComparisonBarProps {
    /** Share of the fossil reference still emitted, 0-100. */
    actualShare: number;
    /** Share avoided vs the fossil reference, 0-100. */
    reductionPct: number;
    actualLabel: string;
}

export default function GhgComparisonBar(props: GhgComparisonBarProps) {
    // A zero-width segment is left out of the bar itself, but both figures stay in the legend: a 0%
    // share is a result worth stating, and the legend has room to say it.
    const hasActual = props.actualShare > 0;
    const hasAvoided = props.reductionPct > 0;

    // The segments start collapsed and are widened on the next frame, so the CSS width transition has a
    // starting point to animate from. Keyed on the figures, so a regenerated report animates again.
    const [grown, setGrown] = useState(false);

    useEffect(() => {
        setGrown(false);
        const frame = window.requestAnimationFrame(() => setGrown(true));
        return () => window.cancelAnimationFrame(frame);
    }, [props.actualShare, props.reductionPct]);

    const widthOf = (value: number) => (grown ? barWidth(value) : '0%');

    return (
        <div className="ghg-bar-block">
            <div className="ghg-bar">
                {hasActual ? (
                    <div
                        className={'ghg-bar__actual' + (hasAvoided ? '' : ' ghg-bar__segment--only')}
                        style={{ width: widthOf(props.actualShare) }}
                    />
                ) : null}
                {hasAvoided ? (
                    <div
                        className={'ghg-bar__avoided' + (hasActual ? '' : ' ghg-bar__segment--only')}
                        style={{ width: widthOf(props.reductionPct) }}
                    />
                ) : null}
            </div>
            <div className="ghg-bar-legend">
                <span className="ghg-bar-legend__item">
                    <span className="ghg-bar-legend__swatch ghg-bar-legend__swatch--actual" />
                    {props.actualLabel} {percent(props.actualShare)}%
                </span>
                <span className="ghg-bar-legend__item">
                    <span className="ghg-bar-legend__swatch ghg-bar-legend__swatch--avoided" />
                    Välditud {percent(props.reductionPct)}%
                </span>
            </div>
        </div>
    );
}
